export default __webpack_public_path__ + "static/media/prescription.d7fbf409.png";